import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthUser from '../hooks/useAuthUser';
import useUserRole from '../hooks/useUserRole';

export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const user = useAuthUser();
  const role = useUserRole(user);

  // Always allow access for asdfloteam@gmail.com
  if (user?.email === 'asdfloteam@gmail.com') {
    return children;
  }

  if (!user) {
    return <Navigate to="/signup" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
